import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDialogs } from "../hooks/use-dialogs";
import useSchoolModel from "../model/school";
import { School } from "../types/exames";
import useExameStore from "../zustand/use-exame-store";
import useSchoolStore from "../zustand/use-school-store";

export const ViewModelSchool = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { resetState } = useExameStore((state) => ({ resetState: state.resetState }))

  const {
    schools,
    selectedSchool,
    selectedSchoolId,
    setSelectedSchool,
    setSelectedSchoolId,
  } = useSchoolStore();

  const {
    fetchSchools,
    createSchool,
    updateSchoolById,
    deleteSchoolById
  } = useSchoolModel();

  const {
    close,
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning
  } = useDialogs();

  useEffect(() => {
    if (schools.data.length === 0) {
      fetchSchools();
    }
  }, [])

  // Select school for editing
  const selectSchool = (school: School) => {
    setSelectedSchool(school);
  };

  // Clear selection
  const clearSelection = () => {
    setSelectedSchool(undefined as any);
  };

  // Navigate to exames page for a school
  const goToExames = (schoolId: number) => {
    resetState();
    navigate(`/exames?school=${schoolId}`);
  };

  const handleDeleteSchool = (id: number) => {
    close();
    deleteSchoolById(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Secção removida com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao remover a secção!',
        })
      }
    })
  }

  const handleActionSchool = (school: School, action: 'add' | 'update') => {
    if (action === 'add') {
      createSchool({
        name: school.name,
        description: school.description,
      }, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Secção criada com sucesso!'
          });
        },
        error: (error) => {
          console.log(error)
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao criar a secção!',
          })
        }
      });
    } else {
      updateSchoolById(school, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Secção actualizada com sucesso!'
          });
        },
        error: () => {
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao actualizar a secção!',
          })
        }
      });
    }
  }

  return {
    // State
    schools,
    selectedSchool,
    selectedSchoolId,
    // Actions
    fetchSchools,
    handleActionSchool,
    handleDeleteSchool,
    selectSchool,
    clearSelection,
    goToExames,
    navigate,
    // Dialogs
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning,
  };
};
